import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Uebungsliste from "./components/Uebungsliste"; // deine neue Component
import Planer from "./components/Planer"; // kommt als nächster Schritt
import "./css/Training.css"

export default function Training() {
  // const [planerAktiv, setPlanerAktiv] = useState(true);
  const planerAktiv = true;
  const [planerItems, setPlanerItems] = useState([]);

  const ageColors = {
    U11: "var(--color-u11)",
    U13: "var(--color-u13)",
    U15: "var(--color-u15)",
    U17: "var(--color-u17)",
    U19: "var(--color-u19)",
    Elite: "var(--color-elite)"
  };

  const location = useLocation();

  useEffect(() => {
    // Wenn ein Hash in der URL steht
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Ein Timeout, damit das Element wirklich gerendert ist
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 200);
    }
  }, [location]);

  function addToPlaner(uebung) {
    // // Doppelte vermeiden
    // if (!planerItems.some(item => item.website === uebung.website)) {
    //   setPlanerItems(prev => [...prev, { ...uebung, dauer: 5 }]);
    // }
    
    // Doppelte sind erlaubt
    setPlanerItems(prev => [...prev, { ...uebung, dauer: 5 }]);
  }

  function removeFromPlaner(id) {
    setPlanerItems(prev => prev.filter(u => u.uid !== id));
  }

  function updateDuration(id, dauer) {
    setPlanerItems(prev =>
      prev.map(u => u.uid === id ? { ...u, dauer } : u)
    );
  }

  function reorderPlaner(newOrder) {
    setPlanerItems(newOrder);
  }

  return (
    <div className="training-page page-content">
      <h1>Training</h1>
      <div className="intro-text">
        <p>Jede Woche Montags und Donnerstags findest du uns ab 17:00 Uhr vor Ort beim Training. Dabei geht es beim Ludwigsfelder Radball Club mit Leidenschaft und Fairplay zu, damit das ganze Team Spaß am Spiel hat.</p>
        <p>Hier sind ein paar unserer Übungen aufgelistet. Mit Hilfe des Planers lassen sich im Handumdrehen Trainingspläne erstellen.</p>
      </div>
      {/* <button
        className="filter-btn"
        onClick={() => setPlanerAktiv(prev => !prev)}
      >
        {planerAktiv ? "❌ Planer deaktivieren" : "📝 Planer aktivieren"}
      </button> */}

      {planerAktiv && (
        <Planer
          items={planerItems}
          setItems={setPlanerItems}
          onRemove={removeFromPlaner}
          onUpdateDuration={updateDuration}
          onReorder={reorderPlaner}
          ageColors={ageColors}
        />
      )}

      <Uebungsliste onAddToPlaner={planerAktiv ? addToPlaner : null} ageColors={ageColors} />
    </div>
  );
}
